
function Footer({eventInfo}:any) {
     return (
         <>
        <footer>
                    <div className="container">
                        <ul className="social-line list-inline">
                            <li className="wow flipInY" data-wow-duration="200ms"><a href="https://x.com/bsidesbangalore" className="twitter"><i className="fa fa-twitter"></i></a></li>
                            <li className="wow flipInY" data-wow-duration="300ms"><a href="https://www.youtube.com/channel/UC0SqOU2NDDIP0bbt5OwW8Hw" className="google"><i className="fa fa-youtube"></i></a></li>
                            <li className="wow flipInY" data-wow-duration="400ms"><a href="https://lnkd.in/gZ8N3Kxr" className="linkedin"><i className="fa fa-linkedin"></i></a></li>
                            <li className="wow flipInY" data-wow-duration="500ms"><a href="https://www.instagram.com/bsides_bangalore" className="instagram"><i className="fa fa-instagram"></i></a></li>
                        </ul>
                        <p>© 2025 BSides Bangalore</p>
                    </div>
                </footer>
         </>
     );
 }

 export {Footer}